import { RadialBarChart } from '@mantine/charts';

import { getSeriesColor } from '#core/lib/formatters/colors.ts';
import { makeFieldFormatter } from '#core/lib/formatters/number-decimals.ts';

import type { ChartRendererProps } from '../types.ts';

/**
 * Renders radial bar chart.
 */
export function RadialBarChartRenderer({ config, width, height }: ChartRendererProps) {
  const radialData = config.data.map((row, i) => {
    const yVal = row[config.yAxis];
    return {
      name: String(row[config.xAxis] ?? `Item ${i + 1}`),
      value: typeof yVal === 'number' ? yVal : 0,
      fill: getSeriesColor(i),
    };
  });

  const size = Math.min(width, height) - 40;
  const formatValue = makeFieldFormatter(config.data, config.yAxis);

  return (
    <RadialBarChart
      data={radialData}
      dataKey="value"
      h={size}
      tooltipProps={{ formatter: (value) => (typeof value === 'number' ? formatValue(value) : String(value)) }}
      w={size}
      withLabels
      withLegend
      withTooltip
    />
  );
}
